var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view'),_c('notifications',{attrs:{"position":"bottom center","group":"app"}}),_c('FooterComponent'),_c('a',{staticClass:"whatsapp",style:(`background-image: url(./../../imgs/whatsapp.png)`),attrs:{"href":"https://wa.me/5511939081255","target":"_blank"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }